// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

// For code in `init` method to work, `liveagent` must be available in the
// global scope.

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, _) {
  "use strict";

  var M = m_module.M;

  var ProactiveChat = function() {};

  ProactiveChat.prototype = {
    /**
     * Used in salesforce API to listen for salesforce-specific events
     * Documentation: https://developer.salesforce.com/docs/
     * atlas.en-us.live_agent_dev.meta/live_agent_dev/
     * live_agent_automated_chat_invitations_API_addButtonEventHandler.htm
     */
    proactiveChatButtonCallback: function(e) {
      // This event fires when the chat invitation appears for the user.
      if (e === liveagent.BUTTON_EVENT.BUTTON_AVAILABLE) {
        M.sendTrackAPI({ feature: 'proactive_chat', event: 'trigger', chat_type: M.proactive_chat_config.chat_type});
      }
    },

    /**
     * Fires track API for accepting the chat. Also starts the chat, and hides
     * the chat invitation.
     */
    acceptChat: function(chat_id) {
      liveagent.startChat(chat_id);
      M.sendTrackAPI({feature:'proactive_chat', event:'open', chat_type: M.proactive_chat_config.chat_type});
    },

    /**
     * Fires track API for rejecting the chat. Also hides the chat invitation.
     */
    rejectChat: function(chat_id) {
      liveagent.rejectChat(chat_id);
      M.sendTrackAPI({feature:'proactive_chat', event:'reject', chat_type: M.proactive_chat_config.chat_type});
    },

    /**
     * Fires off all the salesforce stuff.
     * @param {String} config - JSON string of configuration info
     * @param {String} userMail - The user's email address, if available
     */
    init: function(config, userMail) {
      var liveagent = window.liveagent;
      if (typeof liveagent === 'undefined') {
        console.error("liveagent is undefined.");
        return;
      }

      try {
        config = JSON.parse(config);
      } catch(e) {
        console.error("Could not read liveagent configuration: " + e.message);
        return;
      }

      // Link customer's email if we provide one. We try to get this
      // if the user is logged in already.
      if (userMail) {
        liveagent.setName(userMail);
        liveagent.addCustomDetail('PersonEmail', userMail).map(
          'Account', 'PersonEmail', false, true);
      }

      // Listen for salesforce events
      liveagent.addButtonEventHandler(config.chat_id,
        this.proactiveChatButtonCallback);

      // Set custom variables
      // To be consumed by salesforce config
      // Exmple:
      //   isArtPk
      //   isHolidayPk
      //   isWeddingP
      //   isWeddingKitten
      //   isHolidayCat
      var customVars = config.custom_vars;
      for (var customVarName in customVars) {
        if (customVars.hasOwnProperty(customVarName)) {
          var customVarValue = customVars[customVarName];
          liveagent.setCustomVariable(customVarName, String(customVarValue));
        }
      }

      // Initialize liveagent. This continually pings salesforce to determine
      // if an agent is available. The identifiers here are unique to Minted.
      liveagent.init(
        'https://d.la4-c1-chi.salesforceliveagent.com/chat',
        config.liveagent_org_values[0],
        config.liveagent_org_values[1]);
    },
  }

  return {
    ProactiveChat: ProactiveChat
  }

});
